module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_schoenholzerswilen-f3e8bfc10a8571ed859a077084021723.png";